export default __webpack_public_path__ + "static/media/myMarker.ccd1e062.png";